import {focusElement, hookToAttributeSelector} from '@wix/panda-js-utils'
import {scheduleDataHooks as DH} from '@wix/wix-events-data-hooks'
import {Text} from '@wix/wix-ui-tpa/cssVars'
import classNames from 'classnames'
import React, {useEffect} from 'react'
import {useSettings} from '../../../../../../commons/hooks/use-settings'
import settingsParams from '../../../../settingsParams'
import {classes} from './schedule-title.st.css'

interface ScheduleTitleProps {
  className?: string
}

export const ScheduleTitle = ({className}: ScheduleTitleProps) => {
  const settings = useSettings()
  const scheduleTitleTag = settings.get(settingsParams.scheduleTitleTag) as string

  useEffect(() => {
    focusElement({selector: hookToAttributeSelector(DH.SCHEDULE_TITLE), preventScroll: true})
  }, [])

  return (
    <Text className={classNames(classes.title, className)} data-hook={DH.SCHEDULE_TITLE} tagName={scheduleTitleTag}>
      {settings.get(settingsParams.scheduleTitleText) as string}
    </Text>
  )
}
